<template>
  <div>
    <div class="seach-wrap">
      <div v-for="(v, i) in searchFormListNew" :key="i">
        <div class="search-item-box" v-if="v.type == 'input'">
          <el-input
            :placeholder="'请输入' + v.lable"
            v-model.trim="searchObj[v.searchItem]"
            class="inp-text"
            size="small"
            clearable
          ></el-input>
        </div>
        <div class="search-item-box" v-if="v.type == 'inputNum'">
          <el-input
            :placeholder="'请输入' + v.lable"
            v-model.trim.number="searchObj[v.searchItem]"
            class="inp-text"
            size="small"
            clearable
          ></el-input>
        </div>
        <div class="search-item-box" v-if="v.type == 'select'">
          <el-select
            v-model="searchObj[v.searchItem]"
            :placeholder="'请选择' + v.lable"
            class="inp-text"
            size="small"
            popper-class="optionsContent"
            filterable
            clearable
            @change="selectChange(v.searchItem, searchObj[v.searchItem])"
          >
            <el-option
              :label="item[v.selectValue]"
              :value="item[v.selectId]"
              v-for="item in v.selectList"
              :key="item[v.selectId]"
            ></el-option>
          </el-select>
        </div>
        <div class="search-item-box" v-if="v.type == 'datapicker'">
          <el-date-picker
            v-model="timeArr"
            type="daterange"
            range-separator="至"
            start-placeholder="开始出行日期"
            end-placeholder="结束出行日期"
            size="small"
            :unlink-panels="true"
            :picker-options="pickerOptions"
            :default-time="['', '']"
            clearable
          >
          </el-date-picker>
        </div>
        <div class="search-item-box" v-if="v.type == 'datapicker2'">
          <el-date-picker
            v-model="timeArr2"
            type="datetimerange"
            range-separator="至"
            start-placeholder="订单创建开始"
            end-placeholder="订单创建结束"
            size="small"
            :unlink-panels="true"
            :picker-options="pickerOptions"
            :default-time="['', '']"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </div>
        <div class="search-item-box" v-if="v.type == 'datapicker20'">
          <el-date-picker
            v-model="timeArr20"
            type="datetimerange"
            range-separator="至"
            start-placeholder="订单创建开始"
            end-placeholder="订单创建结束"
            size="small"
            :unlink-panels="true"
            :picker-options="pickerOptions"
            :default-time="['', '']"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </div>
        <div class="search-item-box" v-if="v.type == 'datapicker21'">
          <el-date-picker
            v-model="timeArr21"
            type="datetimerange"
            range-separator="至"
            start-placeholder="订单付款开始"
            end-placeholder="订单付款结束"
            size="small"
            :unlink-panels="true"
            :picker-options="pickerOptions"
            :default-time="['', '']"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </div>
        <div class="search-item-box" v-if="v.type == 'datapicker3'">
          <el-date-picker
            v-model="timeArr3"
            type="daterange"
            range-separator="至"
            start-placeholder="开立开始日期"
            end-placeholder="开立结束日期"
            size="small"
            :unlink-panels="true"
            :picker-options="pickerOptions"
            :default-time="['', '']"
            clearable
          >
          </el-date-picker>
        </div>
        <div class="search-item-box" v-if="v.type == 'DateTimePicker'">
          <el-date-picker
            size="small"
            :picker-options="pickerOptions"
            v-model="searchObj[v.searchItem]"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="seach-btn">
        <el-button type="primary" @click="sendParentObj()" size="small"
          >查询</el-button
        >
        <el-button type="primary" plain @click="resetSeach" size="small"
          >重置</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getByCountryBid } from '@/api/visaCategory';
export default {
  data() {
    return {
      searchFormListNew: [],
      pickerOptions: {
        disabledDate(time) {
          // 如果为日期为今天,则可选中
          if (time.toLocaleDateString() == new Date().toLocaleDateString()) {
            return false;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      timeArr: [],
      timeArr2: [],
      timeArr3: [],
      timeArr20: [],
      timeArr21: [],
      searchObj: {
        pageSize: 10,
        pageNum: 1,
      },
    };
  },
  props: {
    searchFormList: {
      type: Array,
    },
  },
  mounted() {
    this.getParentData();
  },
  methods: {
    //得到父组件的传值并且进行初始化的处理
    getParentData() {
      this.searchFormListNew = this.searchFormList;
      this.searchFormListNew.forEach((event) => {
        if (
          event.type != 'datapicker' &&
          event.type != 'datapicker2' &&
          event.type != 'datapicker20' &&
          event.type != 'datapicker21'
        ) {
          this.$set(this.searchObj, event.searchItem, event.value);
        }
      });
    },
    //数据发送到父组件从
    sendParentObj() {
      // console.log(this.searchObj);
      this.searchFormListNew.forEach((event) => {
        if (event.type == 'datapicker') {
          this.searchObj.minTravelDate =
            this.timeArr && this.timeArr.length ? this.timeArr[0] : null;
          this.searchObj.maxTravelDate =
            this.timeArr && this.timeArr.length ? this.timeArr[1] : null;
          if (this.searchObj.minTravelDate) {
            this.searchObj.minTravelDate = this.dateFormat(
              this.searchObj.minTravelDate
            );
          }
          if (this.searchObj.maxTravelDate) {
            this.searchObj.maxTravelDate = this.dateFormat(
              this.searchObj.maxTravelDate
            );
          }
        }
        if (event.type == 'datapicker2') {
          this.searchObj.minCreateTime =
            this.timeArr2 && this.timeArr2.length ? this.timeArr2[0] : null;
          this.searchObj.maxCreateTime =
            this.timeArr2 && this.timeArr2.length ? this.timeArr2[1] : null;
          // if (this.searchObj.minCreateTime) {
          //   this.searchObj.minCreateTime = this.dateFormat(
          //     this.searchObj.minCreateTime
          //   );
          // }
          // if (this.searchObj.maxCreateTime) {
          //   this.searchObj.maxCreateTime = this.dateFormat(
          //     this.searchObj.maxCreateTime
          //   );
          // }
        }
        if (event.type == 'datapicker20') {
          this.searchObj.createStartTime =
            this.timeArr20 && this.timeArr20.length ? this.timeArr20[0] : null;
          this.searchObj.createEndTime =
            this.timeArr20 && this.timeArr20.length ? this.timeArr20[1] : null;
        }
        if (event.type == 'datapicker21') {
          this.searchObj.paidStartTime =
            this.timeArr21 && this.timeArr21.length ? this.timeArr21[0] : null;
          this.searchObj.paidEndTime =
            this.timeArr21 && this.timeArr21.length ? this.timeArr21[1] : null;
        }
        if (event.type == 'datapicker3') {
          this.searchObj.startDate =
            this.timeArr3 && this.timeArr3.length ? this.timeArr3[0] : null;
          this.searchObj.endDate =
            this.timeArr3 && this.timeArr3.length ? this.timeArr3[1] : null;
          if (this.searchObj.startDate) {
            this.searchObj.startDate = this.dateFormat(
              this.searchObj.startDate
            );
          }
          if (this.searchObj.endDate) {
            this.searchObj.endDate = this.dateFormat(this.searchObj.endDate);
          }
        }
      });
      this.searchObj.pageNum = 1;
      this.$emit('update', this.searchObj);
    },

    selectChange(name, id) {
      if (name == 'countryBid' && id) {
        getByCountryBid(id).then((res) => {
          if (res.code == 200) {
            this.searchFormListNew.forEach((item) => {
              if (item.searchItem == 'categoryBid') {
                item.selectList = res.data;
              }
            });
          }
        });
      } else if (name == 'countryBid' && !id) {
        this.searchFormListNew.forEach((item) => {
          if (item.searchItem == 'categoryBid') {
            item.selectList = [];
          }
        });
      }
    },
    addEvent() {
      this.$emit('addMsg');
    },
    resetSeach() {
      this.getParentData();
      this.$emit('update');
    },
    //时间转换----------------------------------------------------------------------
    dateFormat(dateData) {
      var date = new Date(dateData);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      const time = y + '-' + m + '-' + d;
      return time;
    },
  },
  watch: {},
};
</script>
